// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* Light 模式 */\n/* Color */\n/* Animation */\n/* Other */\n.header-connect-wallet .connect-wallet-but .button-common .marginXBridge {\n  padding-left: 16px;\n  padding-right: 16px;\n}", ""]);
// Exports
module.exports = exports;
